import { memo } from "react";
import { Backdrop, CircularProgress } from "@mui/material";

const LogoLoader = () => {
  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={true}
      transitionDuration={500}
    >
      <CircularProgress
        size={52}
        thickness={4.8}
        sx={{
          color: "#C49A27",
          filter: "drop-shadow(0 0 6px rgba(196, 154, 39, 0.5))",
        }}
      />
    </Backdrop>
  );
};

export default memo(LogoLoader);
